"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var capitalize_1 = tslib_1.__importDefault(require("lodash/capitalize"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var util_1 = require("@gooddata/util");
var OperatorDropdownBody_1 = tslib_1.__importDefault(require("./OperatorDropdownBody"));
var measureValueFilterOperator_1 = require("./helpers/measureValueFilterOperator");
var OperatorDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(OperatorDropdown, _super);
    function OperatorDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            opened: false,
        };
        _this.handleOperatorSelected = function (operator) {
            _this.closeOperatorDropdown();
            _this.props.onSelect(operator);
        };
        _this.closeOperatorDropdown = function () { return _this.setState({ opened: false }); };
        _this.handleOperatorDropdownButtonClick = function () {
            return _this.setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { opened: !state.opened })); });
        };
        return _this;
    }
    OperatorDropdown.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderDropdownButton(),
            this.state.opened ? (react_1.default.createElement(OperatorDropdownBody_1.default, { alignTo: ".gd-mvf-operator-dropdown-button", onSelect: this.handleOperatorSelected, selectedOperator: this.props.operator, onClose: this.closeOperatorDropdown })) : null));
    };
    OperatorDropdown.prototype.renderDropdownButton = function () {
        var _a = this.props, intl = _a.intl, operator = _a.operator, isDisabled = _a.isDisabled;
        var opened = this.state.opened;
        var title = capitalize_1.default(intl.formatMessage({ id: measureValueFilterOperator_1.getOperatorTranslationKey(operator) }));
        var buttonClasses = classnames_1.default("gd-mvf-operator-dropdown-button", "s-mvf-operator-dropdown-button", "s-mvf-operator-dropdown-button-" + util_1.stringUtils.simplifyText(operator), "gd-button-primary", "gd-button-small", {
            "button-dropdown": true,
            "is-dropdown-open": opened,
            "is-active": opened,
        });
        return (react_1.default.createElement(sdk_ui_kit_1.Button, { title: title, className: buttonClasses, value: title, onClick: this.handleOperatorDropdownButtonClick, iconLeft: "gd-icon-" + measureValueFilterOperator_1.getOperatorIcon(operator), iconRight: opened ? "gd-icon-navigateup" : "gd-icon-navigatedown", disabled: isDisabled }));
    };
    return OperatorDropdown;
}(react_1.default.PureComponent));
exports.OperatorDropdown = OperatorDropdown;
exports.default = react_intl_1.injectIntl(OperatorDropdown);
//# sourceMappingURL=OperatorDropdown.js.map